import { useLingui } from "@lingui/react/macro";
import TextArea from "@/components/TextArea/TextArea";
import { useFormContext, type FieldValues } from "react-hook-form";
import {
  useFieldPathWithPrefix,
  useFieldErrorWithPrefix,
} from "@/forms/FormFieldPathPrefixContext";
import type { TemplateDescriptionInputFields } from "../templateFormSchema";

export const TemplateDescriptionInput = () => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
  } = useFormContext<FieldValues>();

  const fieldName =
    useFieldPathWithPrefix<TemplateDescriptionInputFields>("description");
  const errorMessage = useFieldErrorWithPrefix<TemplateDescriptionInputFields>(
    errors,
    "description",
  );

  return (
    <TextArea
      label={t`Beskrivning`}
      showOptionalLabel
      description={t`Visas inte för patienten`}
      errorMessage={errorMessage}
      {...register(fieldName)}
    />
  );
};
